import { Position, Toaster, Intent } from "@blueprintjs/core";
 
/** Singleton toaster instance. Create separate instances for different options. */
const AppToaster = Toaster.create({
    className: "lm-toaster",
    position: Position.TOP,
    autoFocus:true,
});

export  default AppToaster;